import * as React from "react";
import classnames from "classnames";

export type BaseModalProps = {
  title: string;
  isActive: boolean;
  children: React.ReactNode;
  onClose: () => void;
  style?: object;
  hasOverflow?: boolean;
};

export const BaseModal: React.FunctionComponent<BaseModalProps> = ({
  title,
  isActive,
  children,
  hasOverflow,
  onClose,
  style,
}) => (
  <div
    className={classnames("modal", {
      "is-active": isActive,
      "has-overflow": hasOverflow,
    })}
  >
    <div
      className="modal-background"
      onClick={onClose}
      style={{ backgroundColor: "rgba(10,10,10,0.6)" }}
    />
    <div className="modal-card" style={style}>
      <div className="modal-card-head has-text-centered">
        <p
          className="title is-5 pt-1 pb-1"
          style={{
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          {title}
        </p>
      </div>
      {children}
    </div>
  </div>
);
